var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap" }, [
      _c("title", [_vm._v(" Privacy policy")]),
      _vm._v(" "),
      _c("h1", [_vm._v("PRIVACY POLICY")]),
      _vm._v(" "),
      _c("h2", [_vm._v("1. Purposes of the processing")]),
      _vm._v(
        '\n\n        We inform that all personal data provided by the User through this \n    app (hereinafter, the "App") will be processed by OWQLO, S.L, as Data \n    Controller of the processing, (hereinafter, "OWQLO") for the following \n    purposes:\n\n        '
      ),
      _c("ul", { staticStyle: { "list-style-type": "none" } }, [
        _c("li", [
          _vm._v(
            "A.\tEnable the provision of requested services; The legal basis\n    for carrying out this data processing is the execution of the \n    contractual obligations assumed by the User and OWQLO in the App. The \n    personal data processed for this purpose will be kept as long as that \n    relationship is maintained and, once it is finalized, during the \n    conservation and prescription periods of the legal liabilities."
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "B.\tKeep you informed, including by electronic means, about \n    news and events related to OWQLO, as well as OWQLO products and \n    services. The legal basis for carrying out this data processing is the \n    freely given consent of the User. Personal data processed for this \n    purpose will be kept until the User withdraws the given consent. The \n    User may indicate expressly whether or not it authorizes the processing \n    of their data at any time."
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("2. Recipients, Data Processors and personal data transfers")
      ]),
      _vm._v(
        "\n\n        Personal data may be communicated to the following third-party \n    recipients: Public Administrations for compliance with legal \n    obligations; and to the following categories of Data Processors: \n    Providers of electronic communications; Suppliers of IT development and \n    online office automation, hosting, SaaS services such as CRM/ERP, \n    accounting, auditing and lawyers. OWQLO may also transfer the personal \n    data to Data Processors located in the United States of America who are \n    members of the Privacy Shield, which has a decision to adopt the \n    European Commission (Execution Decision (EU) 2016/1250 of the \n    Commission).\n\n    "
      ),
      _c("h2", [_vm._v("3. Rights of the Users")]),
      _vm._v(
        "\n\n        The interested party is, at any time, entitled to exercise the \n    rights of access, rectification, erasure, restriction of processing, \n    data portability and object by email addressed to support@owqlo.com or \n    by letter addressed to OWQLO, C/Fernando El Santo, nº 27, 4º A 28010 - \n    Madrid (Spain). The users have the right to withdraw consent at any \n    time, without affecting the lawfulness of processing based on consent \n    before its withdrawal. The users have, as well, the right to lodge a \n    complaint with a supervisory authority.\n\n    "
      ),
      _c("h2", [_vm._v("4. Display of User data by other Users")]),
      _vm._v(
        "\n\n    The User knows and accepts that when registering in the App, other Users will be able to visit and view their profile.\n\n    "
      ),
      _c("h2", [_vm._v("5. Under-age Users")]),
      _vm._v(
        "\n\n    When the User is under 14 years old, will be required the consent of\n    their respective legal guardians in order to get signed up in the App. \n    They will must enter their name, surname, email address and the number \n    of their national identity document at the time of registration in the \n    App. After, said legal guardian will have to verify it through the \n    e-mail address previously provided.\n\n    "
      ),
      _c("h2", [_vm._v("6. OWQLO as Data Processor")]),
      _vm._v(
        "\n\n    OWQLO will be the Data Processor of all those User?s personal data \n    that needs to be accessed for the correct provision of the requested \n    services, except those already treated in section 1 of this Privacy \n    Policy.\n\n    Said personal data may be classified into the following categories \nof data:    \n    "
      ),
      _c("ul", { staticStyle: { "list-style-type": "none" } }, [
        _c("li", [_vm._v("1.\tIdentification data.")]),
        _vm._v(" "),
        _c("li", [_vm._v("2.\tPersonal characteristics data.")]),
        _vm._v(" "),
        _c("li", [_vm._v("3.\tAcademic and professional data.")]),
        _vm._v(" "),
        _c("li", [_vm._v("4.\tData related to health.")])
      ]),
      _vm._v("\n\n\n\n\n    In this regard, OWQLO undertakes:\n    "),
      _c("ul", { staticStyle: { "list-style-type": "none" } }, [
        _c("li", [
          _vm._v(
            "a) Processing personal data only following documented \n    instructions from the User, including with regard to transfers of \n    personal data, unless required to do so by Union or Member State law; in\n    such case, the Processor will inform User of that legal requirement \n    before processing, unless that Law prohibits such information on \n    important grounds of public interests."
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "b) Ensure that the persons authorised to process personal data\n    have committed themselves to confidentiality or are under an \n    appropriate statutory obligation of confidentiality. "
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "c) Take all measures required pursuant to Article 32 of the Regulation. "
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "d) When the Data Processor turns to another person in charge \n    to carry out certain treatment activities, he will impose on the other \n    person in charge, by contract, the same data protection obligations as \n    those stipulated in this Contract. e) Assist the User, taking into \n    account the nature of the processing, by appropriate technical and \n    organisational measures, insofar as this is possible, for the fulfilment\n    of the User?s obligation to respond to requests for exercising the data\n    subject?s rights. In this case, the Processor must communicate it by \n    email to the following address. The communication must be made \n    immediately."
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "f) Assists the User in ensuring compliance with the \n    obligations pursuant to Articles 32 to 36 taking into account the nature\n    of processing and the information available to the Processor. g) At the\n    choice of the User, deletes or returns all the personal data to the \n    User after the end of the provision of services relating to processing, \n    and deletes existing copies unless Union or Member State law requires \n    storage of the personal data."
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "h) Makes available to the User all information necessary to \n    demonstrate compliance with the obligations laid down in Article 28 of \n    the Regulation. "
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "i) Inform the User immediately if, in the opinion of the \n    Processor, when an instruction infringes the Regulation or other data \n    protection rule from the Union or Member State."
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "j) Comply with any other obligation set by the current data protection regulations. "
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            " k) Notify to the User, without undue delay and where \n    feasible, through email, any personal data breach with all the relevant \n    information for the documentation, resolution and communication of the \n    incident."
          )
        ]),
        _c("br")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26a19b9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a19b9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/docs/privacyPolicy.vue
// module id = null
// module chunks = 